import React from 'react';
import moment from 'moment';
import * as S from './styles';
import { Title } from '../../types';

export const renderSubItems = (item: Title[]) => {
  return [
    null,
    null,
    <S.ColumnSubrow key={1}>
      <span>Nº documento</span>
      {item.map(row => (
        <p key={row.idTitulo}>{row.numeroTitulo}</p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={2}>
      <span>Tipo documento</span>
      {item.map(row => (
        <p key={row.idTitulo}>{row.nomeTitulo}</p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={3}>
      <span>Tipo movimento</span>
      {item.map(row => (
        <p key={row.idTitulo}>{row.tipoMovimento}</p>
      ))}
    </S.ColumnSubrow>,

    <S.ColumnSubrow key={4}>
      <span>Competência</span>
      {item.map(row => (
        <p key={row.idTitulo}>{moment(row.dataCompetencia).format('DD/MM/YYYY')}</p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={5}>
      <span>Data vencimento</span>
      {item.map(row => (
        <p key={row.idTitulo}>{moment(row.dataVencimento).format('DD/MM/YYYY')}</p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={6}>
      <span>Data venc. original</span>
      {item.map(row => (
        <p key={row.idTitulo}>{row.dataContabilizacao ? moment(row.dataContabilizacao).format('DD/MM/YYYY') : '-'}</p>
      ))}
    </S.ColumnSubrow>,

    <S.ColumnSubrow key={7}>
      <span>Valor</span>
      {item.map(row => (
        <p key={row.idTitulo}>
          {row.valorVencimentoOriginal?.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={7}>
      <span>Desconto Juros</span>
      {item.map(row => (
        <p key={row.idTitulo}>
          {row.valorDescontoJuros?.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={7}>
      <span>Desconto Multa</span>
      {item.map(row => (
        <p key={row.idTitulo}>
          {row.valorDescontoMulta?.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ))}
    </S.ColumnSubrow>,
    <S.ColumnSubrow key={8}>
      <span>Correção monetária</span>
      {item.map(row => (
        <p key={row.idTitulo}>
          {row.valorCorrecaoMonetaria?.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ))}
    </S.ColumnSubrow>,
  ];
};
